import React, { CSSProperties, PropsWithChildren } from 'react';
import LoadingView from '@/components/LoadingView';
import { useSafeState, useUpdateEffect } from 'ahooks';
import classNames from 'classnames';
import styles from './index.module.less';
interface IProps {
  loading: boolean;
  backgroundColor?: string;
  className?: string;
  hSize?: 'small' | 'default' | null;
  style?: CSSProperties;
}
const SpinContainer = React.memo((props: PropsWithChildren<IProps>) => {
  const {
    loading,
    className,
    backgroundColor = 'white',
    children,
    hSize = 'default',
    style,
  } = props;
  const [showLoading, setShowLoading] = useSafeState(loading);
  useUpdateEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (loading) {
      setShowLoading(true);
    } else {
      timer = setTimeout(() => {
        setShowLoading(false);
      }, 200);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [loading]);
  return (
    <div
      className={classNames(className, {
        [styles.defaultContainer]: showLoading,
        [styles.small]: hSize === 'small',
        [styles.default]: hSize === 'default',
      })}
      style={{ position: 'relative', ...style }}
    >
      {children}
      <LoadingView
        loading={showLoading}
        backgroundColor={backgroundColor}
        limit={false}
      />
    </div>
  );
});
export default SpinContainer;
